import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import styled from 'styled-components';
import { Card, CardBody, CardSubhead, CardTitle } from '@spark/ui-components/components/Card';
import JanelaDescargaHint, { CardTitleRow } from './JanelaDescargaHint';

const LojasComMaisAtrasosCard = ({
  data,
  loading
}) => (
  <Card>
    <CardBody>
      <CardTitleRow>
        <CardTitle>Lojas com mais atraso de descarga</CardTitle>
        <JanelaDescargaHint />
      </CardTitleRow>
      <CardSubhead>Descargas totais e atrasos acima de 6 horas</CardSubhead>

      <ChartArea>
        {loading ? (
          <EmptyState>Carregando metricas...</EmptyState>
        ) : data.length === 0 ? (
          <EmptyState>Nenhum registro encontrado.</EmptyState>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 10, right: 16, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="loja" tickLine={false} axisLine={false} />
              <YAxis allowDecimals={false} tickLine={false} axisLine={false} />
              <Tooltip />
              <Bar dataKey="atrasos" name="Atrasos de descarga (>6h)" fill="#ff4d4f" radius={[2, 2, 0, 0]} />
              <Bar dataKey="cargasTotais" name="Descargas Totais" fill="#2ca6d9" radius={[2, 2, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </ChartArea>

      <LegendFooter>
        <LegendItem>
          <LegendDot color="#ff4d4f" />
          <span>Atrasos de descarga (&gt;6h)</span>
        </LegendItem>
        <LegendItem>
          <LegendDot color="#2ca6d9" />
          <span>Descargas Totais</span>
        </LegendItem>
      </LegendFooter>
    </CardBody>
  </Card>
);

const ChartArea = styled.div`
  height: 270px;
  margin-top: 18px;
`;

const LegendFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 18px;
  margin: 18px -20px -20px;
  padding: 12px 20px 18px;
  border-top: 1px solid #d8dde3;
`;

const LegendItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #4b5563;
  font-size: 13px;
  font-weight: 600;
`;

const LegendDot = styled.span`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: ${({ color }) => color};
  display: inline-block;
  flex: 0 0 14px;
`;

const EmptyState = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  background: #f8f9fa;
  border: 1px dashed #d8dde3;
`;

export default LojasComMaisAtrasosCard;
